module.exports = __webpack_public_path__ + "img/ic_ding_shi.d324617c.png";